import { render, staticRenderFns } from "./disposalMain.vue?vue&type=template&id=5de22234&scoped=true&"
import script from "./disposalMain.vue?vue&type=script&lang=js&"
export * from "./disposalMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de22234",
  null
  
)

export default component.exports